<template>
  <v-application>
    <v-card class="ma-2">
      <v-card-text>
        <v-form v-model="is_valid">
          <v-layout mx-2>
            <!-- <v-flex md6 px-2>
              <v-text-field
                v-model="currenct_workgroup_order.title"
                :label="$t('title')"
                :rules="[fieldRules.required]"
              />
            </v-flex> -->
            <v-flex md6 px-2>
              <v-select
                v-model="currenct_workgroup_order.priority"
                :label="$t('priority')"
                :items="priorities"
                item-value="value"
                item-text="text"
                :append-icon="''"
                :rules="[fieldRules.required]"
              />
            </v-flex>
            <v-flex md6 px-2>
              <v-autocomplete
                v-model="currenct_workgroup_order.service"
                :label="$t('store')"
                :items="services"
                item-value="_id"
                item-text="name"
                :no-data-text="no_stores_found"
                :rules="[fieldRules.required]"
              />
            </v-flex>
          </v-layout>
          <v-layout mx-2>
            <v-flex md6 px-2>
              <v-autocomplete
                v-model="currenct_workgroup_order.item_id"
                :label="$t('item')"
                :items="workgroup_order_items"
                item-text="name"
                item-value="_id"
                v-on:update:search-input="load_workgroup_order_items"
              />
            </v-flex>
            <v-flex md6 px-2>
              <v-text-field
                v-model.number="currenct_workgroup_order.order_item_count"
                type="number"
                :label="$t('count')"
                autocomplete="off"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout mx-2>
            <v-flex md12 px-2>
              <v-text-field
                v-model="currenct_workgroup_order.comment"
                :label="$t('comment')"
                autocomplete="off"
              />
            </v-flex>
          </v-layout>

          <v-layout row mx-2>
            <v-flex
              md6
              px-2
              v-for="(comm, index) in workgroup_comments"
              :key="index + 'C'"
            >
              <v-text-field
                v-model="currenct_workgroup_order.info[comm]"
                :label="comm"
                autocomplete="off"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
        <v-layout mx-2 px-2>
          <!-- <v-flex md12 px-2> -->
          <p class="subtitle-1 black--text">{{ $t("workgroups") }}</p>
          <v-spacer />
          <v-btn text color="primary" @click="show_workgroup = !show_workgroup">
            {{ $t("show_all") }}
          </v-btn>
        </v-layout>
        <v-expand-transition>
          <v-card v-show="show_workgroup" class="mx-auto" flat>
            <div
              :style="index == 0 ? 'border-top: solid green 0.5px' : ''"
              class="styleBorder"
              v-for="(item, index) in workgroups"
              v-bind:key="index"
            >
              <v-layout mx-4 pt-3>
                <v-flex md2 px-2>
                  <v-icon>mdi-menu</v-icon>
                </v-flex>

                <v-flex md5 px-2 class="black--text">
                  <p class="subtitle-2">{{ item.name }}</p>
                </v-flex>

                <v-flex md3 px-2 class="black--text">
                  <div style="max-width: 50px">
                    <v-text-field
                      class="ma-0 pa-0"
                      v-model.number="item.position_index"
                    />
                  </div>
                </v-flex>

                <v-flex md2 px-2 class="text-right">
                  <v-btn icon @click="removeWorkgroup(index)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-card>
        </v-expand-transition>
        <!-- </v-flex> -->
        <!-- <draggable :list="workgroups" tag="div" class="container">
            <div
              v-for="(item, index) in workgroups"
              v-bind:key="index"
              class="styleBorder"
              :style="index == 0 ? 'border-top: solid green 0.5px' : ''"
            >
              <v-layout mx-2 pt-3>
                <v-flex md2 px-2>
                  <v-icon>mdi-menu</v-icon>
                </v-flex>

                <v-flex md5 px-2 class="black--text">
                  {{ item.name }}
                </v-flex>

                <v-flex md3 px-2 class="black--text">
                  <div style="max-width: 50px">
                    <v-text-field
                      class="ma-0 pa-0"
                      v-model.number="item.position_index"
                    />
                  </div>
                </v-flex>

                <v-flex md2 px-2 class="text-right">
                  <v-btn icon @click="removeWorkgroup(index)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </draggable> -->

        <v-layout v-if="workgroups.length == 0" mx-2>
          <v-spacer />
          <v-btn text color="primary" @click="get_workgroup">
            <v-icon>mdi-reload</v-icon> {{ $t("reset_workgroups") }}
          </v-btn>
        </v-layout>

        <!-- <v-layout mx-2>
          <v-flex md8 px-2>
            <v-autocomplete
              v-model="currenct_workgroup_order.tech_map_id"
              :label="$t('tech_map_item')"
              hide-no-data
              v-bind:items="tech_maps"
              item-text="product_name"
              item-value="_id"
              v-on:update:search-input="searchTechMaps"
            />
          </v-flex>
          <v-flex md4 px-2>
            <v-text-field
              v-model.number="currenct_workgroup_order.order_item_count"
              type="number"
              :label="$t('count')"
              autocomplete="off"
            ></v-text-field>
          </v-flex>
        </v-layout> -->
        <v-layout mx-2>
          <v-flex md12 px-2>
            <v-data-table
              v-bind:headers="items_headers"
              v-bind:items="items"
              hide-default-footer
              disable-sort
              :items-per-page="200000"
              :no-data-text="$t('choose_at_least_one_item')"
            >
              <template v-slot:[`item.name`]="{ item }">
                <v-list-item-content
                  style="
                    width: 350px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                >
                  <v-list-item-title>{{ item.product_name }}</v-list-item-title>
                  <v-list-item-subtitle
                    >SKU {{ item.sku }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </template>
              <template v-slot:[`item.quantity`]="{ item }">
                <v-text-field
                  type="number"
                  class="right-input"
                  v-model="item.quantity"
                  @focus="$event.target.select()"
                >
                </v-text-field>
              </template>
              <template v-slot:[`item.cost`]="{ item }">
                <vuetify-money
                  class="right"
                  v-model="item.cost"
                  v-bind:options="
                    item.cost_currency == 'usd' ? moneyOptionsUSD : moneyOptions
                  "
                ></vuetify-money>
              </template>
              <template v-slot:[`item.remove`]="{ item }">
                <v-btn icon @click="removeItem(item.product_id)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout mx-2>
          <v-flex md12 px-2>
            <v-search-items
              v-bind:label="$t('add_item')"
              v-bind:items="items_list"
              v-bind:selectedAct="add_item"
              v-bind:searchItems="getItems"
              v-bind:loading_inv_items="loading_inv_items"
              v-bind:rules="
                items && items.length == 0 ? [fieldRules.required] : []
              "
            ></v-search-items>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="px-5">
        <v-spacer />
        <v-btn text @click="goBack">
          {{ $t("cancel") }}
        </v-btn>
        <v-btn
          text
          color="primary"
          :loading="saving_document"
          :disabled="saveDisabled"
          @click="saveWorkgroupOrder('pending')"
        >
          {{ $t("save") }}
        </v-btn>
        <v-btn
          text
          color="primary"
          :loading="saving_document"
          :disabled="saveDisabled"
          @click="saveWorkgroupOrder('draft')"
        >
          {{ $t("save_as_draft") }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="exist_dialog" persistent width="500">
      <v-card>
        <v-card-text class="pa-5 black--text"
          >This item has already been added</v-card-text
        >
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="exist_dialog = false">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-application>
</template>

<script>
import Services from "../../mixins/services";
import Customers from "../../mixins/customer/customer";
import Workgroups from "../../mixins/employees/workgroup";
import WorkgroupOrder from "../../mixins/employees/workgroup_order";
import WorkgroupComments from "../../mixins/employees/workgroup_comments";
import TechMap from "../../mixins/items/tech_map";

export default {
  name: "workgroup_create",
  mixins: [
    WorkgroupComments,
    Services,
    Customers,
    Workgroups,
    WorkgroupOrder,
    TechMap
  ],
  data: () => ({
    currenct_workgroup_order: {
      title: null,
      priority: "normal",
      service: null,
      client_id: null,
      comment: "",
      info: {},
      order_item_count: 1
    },
    loading_inv_items: false,
    search_text: "123",
    items_list: [],
    items: [],
    exist_dialog: false,
    saving_document: false,
    is_valid: false,
    client_search: "",
    client_search_text: "123",
    workgroup_order_items: [],
    workgroup_order_item_search: "123",
    tech_map_search: "123",
    items_with_quality_map: {},
    first_time: false,
    first_time_count: false,
    show_workgroup: false
  }),
  watch: {
    "currenct_workgroup_order.service"() {
      this.getItems("", true);
    },
    "currenct_workgroup_order.order_item_count"() {
      if (!this.currenct_workgroup_order._id && this.first_time_count) {
        this.first_time_count = false;
      }
      if (typeof this.currenct_workgroup_order.order_item_count != "number") {
        return;
      }

      for (const index in this.items) {
        const item = this.items[index];
        if (!this.items_with_quality_map[item.product_id]) {
          continue;
        }
        if (!this.first_time_count) {
          this.items[index].quantity =
            this.items_with_quality_map[item.product_id] *
            this.currenct_workgroup_order.order_item_count;
        }
      }
      this.first_time_count = false;
    },
    async "currenct_workgroup_order.tech_map_id"() {
      // await this.getByIdTechMap();
      // if (this.tech_map && this.tech_map.composite_items instanceof Array) {
      //   for (const index in this.tech_map.composite_items) {
      //     this.tech_map.composite_items[
      //       index
      //     ].quantity = this.tech_map.composite_items[index].quality;
      //   }
      //   this.items_with_quality_map = {};
      //   for (const it of this.tech_map.composite_items) {
      //     this.items_with_quality_map[it.product_id] = it.quality;
      //   }
      //   if (!this.first_time) {
      //     this.items = this.tech_map.composite_items;
      //   }
      //   this.first_time = false;
      // }
    },
    async "currenct_workgroup_order.item_id"() {
      await this.load_composite_items();
    },
    services: {
      deep: true,
      handler() {
        if (this.services instanceof Array) {
          this.currenct_workgroup_order.service = this.services[0]._id;
        }
      }
    }
  },
  computed: {
    tech_map_id() {
      return this.currenct_workgroup_order.tech_map_id;
    },
    priorities() {
      return [
        { text: this.$t("urgent"), value: "urgent" },
        { text: this.$t("normal"), value: "normal" },
        { text: this.$t("low"), value: "low" }
      ];
    },
    items_headers() {
      return [
        { text: this.$t("item"), value: "name" },
        {
          text: this.$t("quantity"),
          value: "quantity",
          align: "right",
          width: 100
        },
        { text: this.$t("price"), value: "cost", align: "right", width: 150 },
        { text: null, value: "remove", align: "center", width: 50 }
      ];
    },
    saveDisabled() {
      let disabled = !this.is_valid || this.workgroups.length == 0;
      return disabled;
    },
    target() {
      return this.$route.params["target"];
    },
    workgroup_order_id() {
      return this.$route.query["id"];
    },
    query() {
      return this.$route.query;
    }
  },
  methods: {
    async load_composite_items() {
      await this.getTechMapByItemId(this.currenct_workgroup_order.item_id);

      if (this.tech_map && this.tech_map.composite_items instanceof Array) {
        if (!this.currenct_workgroup_order._id) {
          this.first_time = false;
        }
        this.currenct_workgroup_order.title = this.tech_map.product_name;
        for (const index in this.tech_map.composite_items) {
          this.tech_map.composite_items[
            index
          ].quantity = this.tech_map.composite_items[index].quality;
        }
        this.items_with_quality_map = {};
        for (const it of this.tech_map.composite_items) {
          this.items_with_quality_map[it.product_id] = it.quality;
        }

        if (!this.first_time) {
          this.items = this.tech_map.composite_items;
        }
      }
      this.first_time = false;
    },
    async load_workgroup_order_items(search_text) {
      if (typeof search_text != typeof "salom") {
        return;
      }
      if (this.workgroup_order_item_search == search_text) {
        return;
      }
      this.workgroup_order_item_search = search_text;
      const items = this.$communicator.then(
        this,
        await this.$communicator("list_of_inv_items", {
          arguments: [20, 1],
          params: {
            service: this.currenct_workgroup_order.service,
            search: search_text
          }
        })
      );

      if (items instanceof Array && items.length > 0) {
        if (
          this.currenct_workgroup_order &&
          this.currenct_workgroup_order.item_id
        ) {
          let exist = false;
          for (const it of items) {
            if (it._id + "" == this.currenct_workgroup_order.item_id + "") {
              exist = true;
            }
          }
          if (!exist) {
            items.push({
              name: this.currenct_workgroup_order.item_name,
              _id: this.currenct_workgroup_order.item_id
            });
          }
        }
        this.workgroup_order_items = items;
      }
    },
    getCustomersRequest(client_search) {
      if (client_search == this.client_search_text) {
        return;
      }
      this.client_search_text = client_search;
      this.getCustomers(client_search);
    },
    removeWorkgroup(index) {
      this.workgroups.splice(index, 1);
    },
    add_item(item) {
      let exist = false;
      for (const itm of this.items) {
        if (itm.product_id == item.product_id) {
          exist = true;
        }
      }
      if (exist) {
        this.exist_dialog = true;
      } else {
        this.items.push({
          product_id: item.product_id,
          quantity: 0,
          product_name: item.product_name,
          sku: item.sku,
          cost: item.price,
          price_currency: item.price_currency
        });
      }
    },
    removeItem(product_id) {
      const items = [];
      for (const item of this.items) {
        if (item.product_id != product_id) {
          items.push(item);
        }
      }
      this.items = items;
    },
    async getForEdit() {
      const workgroup_order = this.$communicator.then(
        this,
        await this.$communicator("workgroup_order_get_for_edit", {
          arguments: [this.workgroup_order_id]
        })
      );
      if (!workgroup_order) {
        this.$router.push("/inventory/workgroup/orders").catch(() => {});
      }
      if (!workgroup_order.info) {
        workgroup_order.info = {};
      }

      const workgroupPositionMap = {};
      for (const wp of workgroup_order.workgroup_positions) {
        workgroupPositionMap[wp.workgroup_id + ""] = wp.position_index;
      }
      const workgroups = [];
      for (const w of this.workgroups) {
        if (workgroup_order.workgroups.includes(w._id)) {
          let position_index = 1;
          if (workgroupPositionMap[w._id + ""]) {
            position_index = workgroupPositionMap[w._id + ""];
          }
          workgroups.push({
            ...w,
            position_index
          });
        }
      }
      this.workgroups = workgroups;
      this.items = workgroup_order.items;

      this.currenct_workgroup_order = workgroup_order;
    },
    async getItems(search, service_changed = false) {
      if (typeof search != typeof "invan") {
        search = "";
      }

      if (this.search_text == search && !service_changed) {
        return;
      }
      this.loading_inv_items = true;
      this.search_text = search;
      const items = this.$communicator.then(
        this,
        await this.$communicator("list_of_inv_items", {
          arguments: [50, 1],
          params: {
            service: this.currenct_workgroup_order.service,
            search: search
          }
        })
      );
      if (items) {
        const items_list = [];
        const inStockMap = {};
        for (const index in items) {
          let search_text =
            items[index].name +
            this.converter(items[index].name) +
            items[index].sku;
          if (
            items[index].barcode &&
            typeof items[index].barcode == typeof []
          ) {
            for (const b of items[index].barcode) {
              search_text += b;
            }
          }
          inStockMap[items[index]._id] = {
            first: items[index].first,
            second: items[index].second
          };

          items_list.push({
            product_id: items[index]._id,
            product_name: items[index].name,
            search_text: search_text,
            sku: items[index].sku,
            barcode: items[index].barcode,
            quality: null,
            price: items[index].price,
            price_currency: items[index].price_currency
          });
        }
        this.items_list = items_list;
      }
      this.loading_inv_items = false;
    },
    async saveWorkgroupOrder(state = "pending") {
      const workgroup_ids = [];
      const workgroup_positions = [];
      for (const w of this.workgroups) {
        workgroup_ids.push(w._id);
        workgroup_positions.push({
          workgroup_id: w._id,
          position_index: w.position_index
        });
      }

      this.saving_document = true;
      const result = await this.createWorkgroupOrder({
        ...this.currenct_workgroup_order,
        workgroups: workgroup_ids,
        workgroup_positions,
        items: this.items,
        state: state
      });
      this.saving_document = false;
      if (result) {
        this.$router.push("/inventory/workgroup/orders").catch(() => {});
      }
    },
    searchTechMaps(search) {
      if (typeof search !== "string") {
        search = "";
      }
      if (this.tech_map_search == search) {
        return;
      }
      this.tech_map_search = search;
      this.getTechMap(search);
    }
  },
  beforeMount() {
    this.get_data = false;
    this.first_time = true;
    this.first_time_count = true;
  },
  async mounted() {
    this.first_time = true;
    this.first_time_count = true;

    await this.getCustomersRequest();
    await this.get_workgroup();
    await this.workgroup_comments_get();
    if (this.workgroup_order_id) {
      await this.getForEdit();
      await this.getTechMap(this.currenct_workgroup_order.tech_map_name);
    } else {
      this.getTechMap("");
    }

    const query = JSON.parse(JSON.stringify(this.query));
    if (query.item_id) {
      this.load_workgroup_order_items(query.item_name);
      this.first_time = false;
      this.currenct_workgroup_order.service = query.service;
      this.currenct_workgroup_order.item_id = query.item_id;
      await this.load_composite_items();
      this.currenct_workgroup_order.order_item_count = +query.order_item_count;
    } else {
      this.load_workgroup_order_items("");
    }
  }
};
</script>

<style scoped>
.styleBorder {
  border-bottom: solid green 0.5px;
  border-left: solid green 0.5px;
  border-right: solid green 0.5px;
}

.right-input input {
  text-align: right;
}
</style>
